import React from "react";
import styled from "@emotion/styled";
import PropTypes from "prop-types";
import { Tab } from "@mediamath/design-system-eng";
import SmartLink from "core/shared/util/SmartLink";
import normalize from "normalize-path";

const StCustomTab = styled(Tab)`
  /* hacks to the semantic-ui component */
  display: flex;
  flex: 1;
  flex-flow: column;
  overflow: hidden;

  & .ui.segment.tab {
    box-shadow: none;
    margin: 0;
    padding: 0;
    border-radius: 0;
    border: none;
  }

  & .ui.segment.active.tab {
    display: flex;
    flex: 1;
    flex-flow: column;
    min-height: 0;
  }
`;

const TabRouter = ({ basePath, tabs, selectedPath, style, setActiveIndex }) => {
  let active = 0;
  const panes = tabs.map(
    ({ name, path, content, dataId, disabled = false }, idx) => {
      const cpath = normalize(`/${basePath}/${path}`);
      if (selectedPath.includes(cpath)) {
        active = idx;
        setActiveIndex(idx);
      }
      return {
        menuItem: {
          as: SmartLink,
          to: cpath,
          name,
          content: name,
          key: path,
          disabled,
          "data-id": dataId || undefined,
        },
        render: () => (
          <Tab.Pane attached={false} key={path}>
            {content}
          </Tab.Pane>
        ),
      };
    }
  );
  return (
    <StCustomTab
      activeIndex={active}
      menu={{ secondary: true, pointing: true }}
      panes={panes}
      style={style}
    />
  );
};

TabRouter.propTypes = {
  basePath: PropTypes.string,
  selectedPath: PropTypes.string,
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      path: PropTypes.string.isRequired,
      content: PropTypes.node.isRequired,
      disabled: PropTypes.bool,
    })
  ),
  style: PropTypes.shape({}),
  setActiveIndex: PropTypes.func,
};

TabRouter.defaultProps = {
  basePath: "/",
  selectedPath: "",
  tabs: [],
  style: {},
  setActiveIndex: () => {},
};

export default TabRouter;
